module.exports = __webpack_public_path__ + "static/media/instagram1.282af4a6.jpg";